export const strings = {
  NAME: "Media",
  DESCRIPTION: "Add an image, video or logo to the page.",
} as const;
